(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const closeNotice = document.querySelector('[data-kea-collection-close-epoch]');
  if (closeNotice) {
    const deadline = Number(closeNotice.dataset.keaCollectionCloseEpoch) * 1000;
    let serverTime = Number(closeNotice.dataset.keaRenderedEpoch) * 1000;
    let anchor = performance.getEntriesByType('navigation')[0]?.responseStart || performance.now();
    let closeTimer;
    const updateCloseState = () => {
      window.clearTimeout(closeTimer);
      const remaining = deadline - (serverTime + performance.now() - anchor);
      if (!Number.isFinite(remaining)) return;
      if (remaining <= 0) {
        const section = closeNotice.closest('.shopify-section');
        section?.querySelectorAll('collection-component').forEach((grid) => {
          grid.hidden = true;
          grid.style.display = 'none';
        });
        closeNotice.dataset.keaCampaignAvailabilityState = 'closed';
        closeNotice.hidden = false;
        return;
      }
      closeTimer = window.setTimeout(updateCloseState, Math.min(remaining, 2147483647));
    };
    const syncCloseClock = () => {
      updateCloseState();
      fetch(window.location.href, { method: 'HEAD', cache: 'no-store' })
        .then((response) => {
          const currentTime = Date.parse(response.headers.get('date'));
          if (!Number.isFinite(currentTime)) return;
          serverTime = Math.max(currentTime, serverTime + performance.now() - anchor);
          anchor = performance.now();
          updateCloseState();
        })
        .catch(() => {});
    };
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) syncCloseClock();
    });
    window.addEventListener('pageshow', syncCloseClock);
    syncCloseClock();
  }
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
